import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import Store from '@/store';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '@/pages/Home.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/pages/About.vue'),
  },
  {
    path: '/slot',
    name: 'Slot',
    component: () => import('@/pages/Slot.vue'),
  },
  {
    path: '/live',
    name: 'Live',
    component: () => import('@/pages/LiveCasino.vue'),
  },
  {
    path: '/fishing',
    name: 'Fishing',
    component: () => import('@/pages/Fishing.vue'),
  },
  {
    path: '/casual',
    name: 'Casual',
    component: () => import('@/pages/Casual.vue'),
  },
  {
    path: '/p2p',
    name: 'P2p',
    component: () => import('@/pages/P2p.vue'),
  },
  {
    path: '/promotion',
    name: 'Promotion',
    component: () => import('@/pages/Promotion.vue'),
  },
  {
    path: '/affiliate-report',
    name: 'AffiliateReport',
    component: () => import('@/pages/AffiliateReport.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.query.ref) {
    await localStorage.setItem('betflix8k-affiliate-program-reference', String(to.query.ref));
  }
  if (to.name === 'AffiliateReport') {
    if (!Store.state.Auth.isLoggedIn) {
      next('/');
      return;
    }
  }
  next();
});

router.afterEach((to) => {
  if (to.query.login) {
    Store.dispatch('Dialog/updateDialog', { open: true, dialogType: 'LoginDialog' });
  }
  if (to.query.register) {
    Store.dispatch('Dialog/updateDialog', { open: true, dialogType: 'RegisterDialog' });
  }
});

export default router;
